var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMusic = function SvgIconMusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.155 3.477a1.54 1.54 0 0 1 1.88 1.503v10.958a3.855 3.855 0 1 0 1.027 2.464V4.98a2.568 2.568 0 0 0-3.133-2.505l-8.242 1.858a2.57 2.57 0 0 0-2.003 2.505v9.101a3.855 3.855 0 1 0 1.027 2.62V6.838c0-.72.5-1.345 1.202-1.503zM5.857 15.732a2.827 2.827 0 1 1 0 5.655 2.827 2.827 0 0 1 0-5.655m9.526 2.829a2.827 2.827 0 1 1 5.655 0 2.827 2.827 0 0 1-5.655 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconMusic;